module.exports = __webpack_public_path__ + "static/img/activity_gift.b50fbf8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/activity_gift.png
// module id = 0w9o
// module chunks = 5